/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { AppContext } from "../../AppContextProvider";
import ExplorerDataComponent from "./ExplorerDataComponent2";
import GraphUserComponent2 from "./GraphUserComponent3";
import NetworkViewGraph from "./NetworkViewGraph";
import { darkColors, lightColors } from "../../data/SampleData";
import { useTranslation } from "react-i18next";
import human_small from "../../assets/media/images/human_small.svg";
import human_small_white from "../../assets/media/images/human_small_white.svg";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import { loadGraphWithJwt, saveUnprocessedGraphJwt } from "../../utils/graph/graphloader2";
import { loadGraphOnce } from "../../utils/graph/graphLoadCoordinator";
import DwinityLoader from "../DwinityLoader";
import logo from "../../assets/media/logos/Dwinity Logo horizontal black.svg";
import {
  interrupt,
  removeAll,
  resetUploadState,
  deleteUploadedFilesOnCancel,
  trackUploadedFile,
  trackUploadingFile,
  getAllTrackedFiles,
  setPlannedUploadPaths,
  addPlannedUploadPaths,
  clearUploadSession,
  setIsCancellingUpload,
} from "../../utils/uploadworker/uploadworkerutil";
import { cancelOrchestratedUpload, isOrchestratedUploadActive } from "../../utils/uploadworker/orchestratedUpload";
import { clearBatchId } from "../../utils/uploadworker/batchIdStorage";
import { NotificationsTicket } from "../TicketsComponent";

/**
 * VÁLTOZÁS 2026-01-05:
 * ImageCarouselComponent helyett UploadProgressInfoComponent használata
 * Követelmény 2.4: Hasznos információk a slideshow helyett
 */
import UploadProgressInfoComponent from "../UploadProgressInfoComponent";

import { MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";
import { useLocation, useNavigate } from "react-router-dom";
import ChatModal from "../../modals/ChatModal";

import {
  TYPE_FILE2,
  findChildrenOfNodeById2,
  addProperties2,
  calculateChildrenCount,
  GROUP_FULL,
  GROUP_EMPTY,
  RELATION_BRIDGE_LINK,
} from "../../utils/graph/graphmodifier2";
import { getFilesList } from "../../utils/dwclient/dwstorage";
import { ensureStorageFilesList2 } from "../../utils/graph/graphstorage2";
import {
  concatLogsAndVars,
  createEmptyLogsAndVars,
  recordVariable,
  ReportingError,
  dwReportError,
} from "../../utils/diagnostics/clientErrors";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import { loadJwt } from "../../utils/dwclient/localstorage/jwtStorage";
import { getMetadataJwt } from "../../utils/dwclient/dwmetadata";
import { unProcessAndSaveProcessedGraphJwt } from "../../utils/graph/graphloader2";
import { canonicalFolderPath } from "../../utils/paths";

import diagram_10 from "../../assets/media/icons/files/diagram-10.svg";
import diagram_20 from "../../assets/media/icons/files/diagram-20.svg";
import diagram_30 from "../../assets/media/icons/files/diagram-30.svg";
import diagram_40 from "../../assets/media/icons/files/diagram-40.svg";
import diagram_50 from "../../assets/media/icons/files/diagram-50.svg";
import diagram_60 from "../../assets/media/icons/files/diagram-60.svg";
import diagram_70 from "../../assets/media/icons/files/diagram-70.svg";
import diagram_80 from "../../assets/media/icons/files/diagram-80.svg";
import diagram_90 from "../../assets/media/icons/files/diagram-90.svg";

import file_10 from "../../assets/media/icons/files/file-10.svg";
import file_20 from "../../assets/media/icons/files/file-20.svg";
import file_30 from "../../assets/media/icons/files/file-30.svg";
import file_40 from "../../assets/media/icons/files/file-40.svg";
import file_50 from "../../assets/media/icons/files/file-50.svg";
import file_60 from "../../assets/media/icons/files/file-60.svg";
import file_70 from "../../assets/media/icons/files/file-70.svg";
import file_80 from "../../assets/media/icons/files/file-80.svg";
import file_90 from "../../assets/media/icons/files/file-90.svg";

import product_10 from "../../assets/media/icons/files/product-10.svg";
import product_20 from "../../assets/media/icons/files/product-20.svg";
import product_30 from "../../assets/media/icons/files/product-30.svg";
import product_40 from "../../assets/media/icons/files/product-40.svg";
import product_50 from "../../assets/media/icons/files/product-50.svg";
import product_60 from "../../assets/media/icons/files/product-60.svg";
import product_70 from "../../assets/media/icons/files/product-70.svg";
import product_80 from "../../assets/media/icons/files/product-80.svg";
import product_90 from "../../assets/media/icons/files/product-90.svg";

import list_10 from "../../assets/media/icons/files/list-10.svg";
import list_20 from "../../assets/media/icons/files/list-20.svg";
import list_30 from "../../assets/media/icons/files/list-30.svg";
import list_40 from "../../assets/media/icons/files/list-40.svg";
import list_50 from "../../assets/media/icons/files/list-50.svg";
import list_60 from "../../assets/media/icons/files/list-60.svg";
import list_70 from "../../assets/media/icons/files/list-70.svg";
import list_80 from "../../assets/media/icons/files/list-80.svg";
import list_90 from "../../assets/media/icons/files/list-90.svg";

import diagram_10_light from "../../assets/media/icons/files/diagram-10-light.svg";
import diagram_20_light from "../../assets/media/icons/files/diagram-20-light.svg";
import diagram_30_light from "../../assets/media/icons/files/diagram-30-light.svg";
import diagram_40_light from "../../assets/media/icons/files/diagram-40-light.svg";
import diagram_50_light from "../../assets/media/icons/files/diagram-50-light.svg";
import diagram_60_light from "../../assets/media/icons/files/diagram-60-light.svg";
import diagram_70_light from "../../assets/media/icons/files/diagram-70-light.svg";
import diagram_80_light from "../../assets/media/icons/files/diagram-80-light.svg";
import diagram_90_light from "../../assets/media/icons/files/diagram-90-light.svg";

import file_10_light from "../../assets/media/icons/files/file-10-light.svg";
import file_20_light from "../../assets/media/icons/files/file-20-light.svg";
import file_30_light from "../../assets/media/icons/files/file-30-light.svg";
import file_40_light from "../../assets/media/icons/files/file-40-light.svg";
import file_50_light from "../../assets/media/icons/files/file-50-light.svg";
import file_60_light from "../../assets/media/icons/files/file-60-light.svg";
import file_70_light from "../../assets/media/icons/files/file-70-light.svg";
import file_80_light from "../../assets/media/icons/files/file-80-light.svg";
import file_90_light from "../../assets/media/icons/files/file-90-light.svg";

import product_10_light from "../../assets/media/icons/files/product-10-light.svg";
import product_20_light from "../../assets/media/icons/files/product-20-light.svg";
import product_30_light from "../../assets/media/icons/files/product-30-light.svg";
import product_40_light from "../../assets/media/icons/files/product-40-light.svg";
import product_50_light from "../../assets/media/icons/files/product-50-light.svg";
import product_60_light from "../../assets/media/icons/files/product-60-light.svg";
import product_70_light from "../../assets/media/icons/files/product-70-light.svg";
import product_80_light from "../../assets/media/icons/files/product-80-light.svg";
import product_90_light from "../../assets/media/icons/files/product-90-light.svg";

import list_10_light from "../../assets/media/icons/files/list-10-light.svg";
import list_20_light from "../../assets/media/icons/files/list-20-light.svg";
import list_30_light from "../../assets/media/icons/files/list-30-light.svg";
import list_40_light from "../../assets/media/icons/files/list-40-light.svg";
import list_50_light from "../../assets/media/icons/files/list-50-light.svg";
import list_60_light from "../../assets/media/icons/files/list-60-light.svg";
import list_70_light from "../../assets/media/icons/files/list-70-light.svg";
import list_80_light from "../../assets/media/icons/files/list-80-light.svg";
import list_90_light from "../../assets/media/icons/files/list-90-light.svg";

export default function ExplorerComponent(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const basicRef = useRef(null);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const context = useContext(AppContext);
  const { selectedAccount, selectedWallet } = useContext(WalletProviderContext);
  const [isDark, setIsDark] = useState(true);
  const [basicActive, setBasicActive] = useState("tab1");
  const [graphData, setGraphData] = useState();
  const [isUserGraph, setIsUserGraph] = useState(false);
  const [preview, setPreview] = useState(isDark ? human_small : human_small_white);
  const [processedGraph, setProcessedGraph] = useState();
  const [isVisibility5, setIsVisibility5] = useState(true);
  const [isVisibility2, setIsVisibility2] = useState(false);
  const [graphLoadError, setGraphLoadError] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isLocalRender, setIsLocalRender] = useState(false);
  const downloadAbortControllerRef = useRef(new AbortController());

  useEffect(() => {
    return () => {
      downloadAbortControllerRef.current.abort(new DOMException("Explorer closed", "AbortError"));
    };
  }, []);

  // Consume the one-shot router state used by InvitationsPage when its Back
  // button should return to and reopen Secure Chat.
  useEffect(() => {
    if (location.state?.openSecureChat === true) {
      setIsChatOpen(true);
      navigate(`${location.pathname}${location.search}`, {
        replace: true,
        state: null,
      });
    }
  }, [location.pathname, location.search, location.state, navigate]);
  const [graphRefreshed, setGraphRefreshed] = useState(false);
  const [isDoneTicket, setIsDoneTicket] = useState(false);
  const [isMultiDownload, setIsMultiDownload] = useState(false);

  /**
   * VÁLTOZÁS 2026-01-05 - Követelmény 2.3/2.4
   * Upload állapot kezelése BroadcastChannel-en keresztül
   * - uploadStatus: aktuális állapot (preparing/encrypting/uploading/completed)
   * - currentFilePath: aktuálisan feltöltött fájl path-ja
   * - folderProgress: mappánkénti progress lista
   * - statusMessage: aktuális állapot üzenet (DE/EN)
   */
  const [uploadStatus, setUploadStatus] = useState("idle");
  const [currentFilePath, setCurrentFilePath] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [folderProgress, setFolderProgress] = useState([]);
  const [completedPaths, setCompletedPaths] = useState(new Set());
  const [isCancelling, setIsCancelling] = useState(false);
  const isCancellingRef = useRef(false);
  const folderStatsRef = useRef(new Map());
  const basePathRef = useRef("/");

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return;

    const broadcast = new BroadcastChannel("upload-channel");

    broadcast.onmessage = (event) => {
      const data = event.data;
      if (!data) return;

      /**
       * VÁLTOZÁS 2026-01-05 - Követelmény 2.4
       * Az "init-folders" üzenet feldolgozása
       * A FileUploadsModal küldi az upload indításakor
       * A basePath-ot is tároljuk, hogy konzisztens legyen a folder path normalizálás
       */
      if (data.status === "init-folders" && data.folderStats) {
        const stats = folderStatsRef.current;
        stats.clear();

        if (data.basePath) {
          basePathRef.current = data.basePath;
        }

        // Handle complete file manifest (legacy format - small uploads)
        if (data.allFilePaths && Array.isArray(data.allFilePaths)) {
          setPlannedUploadPaths(data.allFilePaths);
          console.log(`Stored upload manifest: ${data.allFilePaths.length} files`);
        }
        
        // Handle batched file paths (new format - large uploads)
        // The actual paths will arrive via file-paths-batch messages
        if (data.batchedFilePaths) {
          console.log(`Upload manifest will arrive in batches (${data.totalFiles} files)`);
        }

        for (const folder of data.folderStats) {
          stats.set(folder.path, {
            total: folder.totalFiles,
            completed: 0,
          });
        }

        setFolderProgress(
          data.folderStats.map((folder) => ({
            path: folder.path,
            totalFiles: folder.totalFiles,
            completedFiles: 0,
            progress: 0,
            completed: false,
          })),
        );
        setCompletedPaths(new Set());
        return;
      }
      
      // Handle batched file paths for large uploads (to avoid 16MB structured clone limit)
      if (data.status === "file-paths-batch" && data.paths) {
        addPlannedUploadPaths(data.paths);
        console.log(`Received file-paths batch ${data.batchIndex + 1}/${data.totalBatches} (${data.paths.length} paths)`);
        return;
      }

      if (data.status === "preparing" || data.status === "encrypting" || data.status === "uploading") {
        if (data.status === "preparing") {
          setIsCancelling(false);
        }
        setUploadStatus(data.status);
        setCurrentFilePath(data.filePath || "");
        if (data.message) {
          setStatusMessage(data.message);
        }

        if (data.status === "uploading" && data.filePath) {
          trackUploadingFile(data.filePath);
        }

        /**
         * VÁLTOZÁS 2026-01-05 - Közös canonicalFolderPath segédfüggvény használata
         * A basePathRef.current-et használjuk defaultRoot-ként a konzisztens normalizáláshoz
         */
        if (data.filePath) {
          const folderPath = canonicalFolderPath(data.filePath, basePathRef.current);
          const stats = folderStatsRef.current;

          if (!stats.has(folderPath)) {
            stats.set(folderPath, { total: data.totalFiles || 1, completed: 0 });
          }

          setFolderProgress(
            Array.from(stats.entries()).map(([path, s]) => ({
              path,
              totalFiles: s.total,
              completedFiles: s.completed,
              progress: s.total > 0 ? (s.completed / s.total) * 100 : 0,
              completed: s.completed >= s.total && s.total > 0,
            })),
          );
        }
      } else if (data.status === "completed" && data.filePath) {
        // Ignore completed messages when cancelling - files will be deleted anyway
        if (isCancellingRef.current) {
          console.log("Ignoring completed status during cancel:", data.filePath);
          return;
        }
        
        setCompletedPaths((prev) => new Set([...prev, data.filePath]));

        trackUploadedFile(data.filePath);

        /**
         * VÁLTOZÁS 2026-01-05 - Közös canonicalFolderPath segédfüggvény használata
         * A basePathRef.current-et használjuk defaultRoot-ként a konzisztens normalizáláshoz
         */
        const folderPath = canonicalFolderPath(data.filePath, basePathRef.current);
        const stats = folderStatsRef.current;

        if (stats.has(folderPath)) {
          const folderStat = stats.get(folderPath);
          folderStat.completed++;
          stats.set(folderPath, folderStat);

          setFolderProgress(
            Array.from(stats.entries()).map(([path, s]) => ({
              path,
              totalFiles: s.total,
              completedFiles: s.completed,
              progress: s.total > 0 ? (s.completed / s.total) * 100 : 0,
              completed: s.completed >= s.total && s.total > 0,
            })),
          );
        }
      } else if (data.status === "finished") {
        // Ignore finished messages when cancelling - the cancel handler manages state
        if (isCancellingRef.current) {
          console.log("Ignoring finished status during cancel");
          return;
        }
        
        setUploadStatus("idle");
        setCurrentFilePath("");
        setStatusMessage("");
        folderStatsRef.current.clear();
        setFolderProgress([]);
        setCompletedPaths(new Set());
        resetUploadState();
      } else if (data.status === "interrupted") {
        // Don't reset state here - the Cancel button handler will do it AFTER deleting files
        console.log("Upload interrupted - cleanup will be handled by cancel handler");
      }
    };

    return () => {
      broadcast.close();
    };
  }, []);

  const currentFolderPath = useMemo(() => {
    if (!currentFilePath) return "";
    const parts = currentFilePath.split("/").filter(Boolean);
    return parts.length > 1 ? parts.slice(0, -1).join("/") : "";
  }, [currentFilePath]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const refreshGraph = () => {
    setGraphRefreshed((prevGraphRefreshed) => {
      return !prevGraphRefreshed;
    });
  };

  const handleBasicClick = (value2) => {
    console.log(`[ExplorerComponent] Tab clicked: ${value2}, current: ${basicActive}`);
    if (value2 === basicActive) {
      console.log(`[ExplorerComponent] Same tab, ignoring`);
      return;
    }
    console.log(`[ExplorerComponent] Switching to tab: ${value2}`);
    setBasicActive(value2);
    setIsLocalRender(!isLocalRender);
  };
  useEffect(() => {
    setPreview(isDark ? human_small : human_small_white);
  }, [isDark]);

  const processGraphNodeValues = (originalGraph) => {
    for (let node of originalGraph.nodes) {
      if (node.value !== undefined) {
        node.value2 = node.value;
        delete node.value;
      }
    }
    return originalGraph;
  };

  const processGraphNodes2 = (originalGraph) => {
    for (let node of originalGraph.nodes) {
      if (node.label !== undefined) {
        /*if (node._type.includes("file")) {
          node.title = node.label;
        }*/
        node.title = node.label;
      }
      if (node.cid > 9) {
        node.cid = 9;
      }
      if (node.level > 9) {
        node.level = 9;
      }
      if (node.cid === 0 && node.level === 1) {
        node.cid = 9;
      }
      if (node.cid === 0 && node.level === 0) {
        node.shape = "circularImage";
        node.image = preview;
      }
      addProperties2(node);
    }
    calculateChildrenCount(originalGraph);
    //console.log(GROUP_FULL + " " + GROUP_EMPTY);
    for (let node of originalGraph.nodes) {
      node.group =
        node.cid +
        "" +
        node.level +
        (node.childrenCount !== undefined && node.childrenCount > 0 ? GROUP_FULL : GROUP_EMPTY);
    }

    return originalGraph;
  };

  //const processedMusterGraph = processGraphNodeValues(MusterGraph);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    let cancelled = false;
    let revealTimer;
    const graphLoadController = new AbortController();

    async function getGraph2() {
      let logsAndVars = createEmptyLogsAndVars("ExplorerComponent:getGraph");
      try {
        if (storageProps.loaded) {
          setGraphLoadError("");
          setIsVisibility5(true);
          let graph = undefined;
          const authToken = (await loadJwt()) ?? "";

          if (authToken === "") {
            throw new Error("The saved login session is no longer available.");
          }
          graph = await loadGraphOnce(authToken, loadGraphWithJwt, graphLoadController.signal);
          if (graph === undefined) {
            throw new Error("The Explorer graph is not available.");
          }
          if (cancelled) return;
          console.log(graph);
          recordVariable(logsAndVars, "graph loaded from backend", graph);
          recordVariable(logsAndVars, "example graph to save", graph);
          await saveUnprocessedGraphJwt(authToken, graph, graphLoadController.signal);
          if (cancelled) return;
          const localProcessedGraph = processGraphNodes2(graph);
          recordVariable(logsAndVars, "processed graph", localProcessedGraph);
          //const filesListResult = await getFilesList(storageProps, "/", true);
          //console.log(filesListResult);
          /*
          const filesListResult = await getFilesList(storageProps, "/", true);

          const graphChanged = await ensureStorageFilesList2(
            selectedWallet?.provider,
            localProcessedGraph,
            filesListResult.entries,
          );
          if (graphChanged) {
            unProcessAndSaveProcessedGraphJwt(authToken, localProcessedGraph);
          }
          */
          for (const node of localProcessedGraph.nodes) {
            addProperties2(node);
          }

          if (cancelled) return;
          setProcessedGraph(localProcessedGraph);
          //console.log(localProcessedGraph);
          context.onProcessed(true);
          revealTimer = setTimeout(() => {
            if (cancelled) return;
            context.isProgress(false);
            setIsVisibility2(true);
            // The main graph is ready. Child views may continue their own
            // bounded work, but must never own the full-page loader lifecycle.
            setIsVisibility5(false);
          }, 100);
        }
      } catch (error) {
        if (cancelled || graphLoadController.signal.aborted) return;
        if (error instanceof ReportingError) {
          logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
        console.log(error?.message ?? error);
        setIsVisibility2(false);
        setIsVisibility5(false);
        setGraphLoadError(
          t("files.explorerLoadFailed", {
            defaultValue: "The Explorer could not be loaded. Please try again.",
          }),
        );
      }
    }
    getGraph2();
    return () => {
      cancelled = true;
      graphLoadController.abort();
      if (revealTimer) clearTimeout(revealTimer);
      context.onProcessed(false);
    };
  }, [storageProps.loaded, graphRefreshed, localStorage.getItem("jwt")]);

  useEffect(() => {
    if (processedGraph === undefined) {
      return;
    }
    if (preview) {
      var n = 0;
      //console.log(processedGraph);
      for (const node of processedGraph.nodes) {
        let fileTypeParts = node._type.split("/");
        let fileTypeLastPart = fileTypeParts[fileTypeParts.length - 1];
        if (fileTypeLastPart === "file") {
          makeLeafNodeDifferentByDataOwner(node);
        }
        if (node.metadataType === "list") {
          makeLeafNodeDifferentByShopping(node);
        }
        if (node.metadataType === "timeseries") {
          makeSeriesNodeDifferent(node);
        }
      }

      for (const edge of processedGraph.edges) {
        makeTagEdgeColor(processedGraph, edge);
      }
      var nodesArray = processedGraph.nodes;
      var edgesArray = processedGraph.edges;
      //var edgesArray = processedGraph.edges;
      var nodesIdList = [];
      /*
      for (let i = 0; i < processedGraph.properties?.length; i++) {
        let propertyParts = processedGraph.properties[i].p.split("/");
        let propertyName = propertyParts[propertyParts.length - 1];
        nodesIdList.push(processedGraph.properties[i].o);
        let selectedS = nodesArray.find((k) => k.id === processedGraph.properties[i].s);
        let selectedO = nodesArray.find((k) => k.id === processedGraph.properties[i].o);
        if (selectedS !== undefined && selectedO !== undefined) {
          if (selectedS.properties === undefined) {
            selectedS.properties = {};
          }

          selectedS.properties[propertyName] =
            selectedO.currency !== undefined ? selectedO.value2 + " " + selectedO.currency : selectedO.value2;
        }
      }
*/
      /*
      for (let i = 0; i < nodesArray.length; i++) {
        makeNodeLabelAndTitle(nodesArray[i]);
        if (nodesIdList.includes(nodesArray[i].id)) {
          nodesArray[i].hidden = true;
        } else {
          nodesArray[i].hidden = false;
        }
        if (nodesArray[i].id === "do123") {
          nodesArray[i].image = preview;
          nodesArray[i].group = "user";
          nodesArray[i].cid = 0;
        }
        let fileTypeParts = nodesArray[i]._type.split("/");
        //let fileTypeParts = nodesArray[i].type.split("/");
        let fileTypeLastPart = fileTypeParts[fileTypeParts.length - 1];
        //let childNodes = findChildrenOfNodeById(processedGraph, nodesArray[i].id, undefined, [RELATION_TAG]);
        let childNodes = findChildrenOfNodeById2(processedGraph, nodesArray[i].id, undefined, [RELATION_TAG]);
        if (childNodes.length === 0) {
          handleChildlessNodes(nodesArray[i], fileTypeLastPart);
        } else {
          handleNodesWithChildren(nodesArray[i], fileTypeLastPart);
        }
      
      }
      var x = nodesArray.filter((k) => k.hidden !== true);
      nodesArray = x;

      for (let i = 0; i < edgesArray.length; i++) {
        edgesArray[i].from = edgesArray[i].s;
        edgesArray[i].to = edgesArray[i].o;

        if (edgesArray[i].s === "do123") {
          edgesArray[i].hidden = false;
        }

        //let edgePropertyEnding = edgesArray[i].p.split("/").at(-1);
        let edgePropertyEnding = edgesArray[i]._type.split("/").at(-1);
        if (edgePropertyEnding !== "has" && edgePropertyEnding !== "contains" && edgePropertyEnding !== "tag") {
          let capitalizedvalue2 = edgePropertyEnding[0].toUpperCase() + edgePropertyEnding.slice(1);
          edgesArray[i].title = capitalizedvalue2.match(/[A-Z][a-z]+|[0-9]+/g)
            ? capitalizedvalue2
                .match(/[A-Z][a-z]+|[0-9]+/g)
                .join(" ")
                .replace("_", " ")
            : edgePropertyEnding.replace("_", " ");
        }
       
      
      }
      */
      //console.log(processedGraph.aux.idToCidMap);
      setGraphData({ nodes: nodesArray, edges: edgesArray, idToCidMap: processedGraph.aux.idToCidMap });
    }
  }, [isDark, preview, processedGraph]);

  const isFile = (node) => {
    //return node.isFile || node.type === TYPE_FILE;
    return node.isFile || node._type === TYPE_FILE2;
  };

  const makeChildlessFirstLevelAndFolderNodeColor = (node) => {
    if (node.cid === 1) {
      node.color = {
        background: !isDark ? "#FFF2B2" : "#231B00",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#FFF2B2" : "#231B00",
        },
      };
    }
    if (node.cid === 2) {
      node.color = {
        background: !isDark ? "#E5E5FF" : "#3F001D",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#E5E5FF" : "#3F001D",
        },
      };
    }
    if (node.cid === 3) {
      node.color = {
        background: !isDark ? "#FFEEE5" : "#351000",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#FFEEE5" : "#351000",
        },
      };
    }
    if (node.cid === 4) {
      node.color = {
        background: !isDark ? "#FFE5F4" : "#131F00",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#FFE5F4" : "#131F00",
        },
      };
    }
    if (node.cid === 5) {
      node.color = {
        background: !isDark ? "#E5FCB5" : "#002103",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#E5FCB5" : "#002103",
        },
      };
    }
    if (node.cid === 6) {
      node.color = {
        background: !isDark ? "#CCEEFF" : "#002012",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#CCEEFF" : "#002012",
        },
      };
    }
    if (node.cid === 7) {
      node.color = {
        background: !isDark ? "#CCFFEB" : "#001D2E",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#CCFFEB" : "#001D2E",
        },
      };
    }
    if (node.cid === 8) {
      node.color = {
        background: !isDark ? "#FFF2B2" : "#130A66",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#FFF2B2" : "#130A66",
        },
      };
    }
    if (node.cid === 9) {
      node.color = {
        background: !isDark ? "#FAFAFB" : "#310049",
        highlight: {
          background: !isDark ? "#FFF" : "#151828",
        },
        hover: {
          background: !isDark ? "#FAFAFB" : "#310049",
        },
      };
    }

    node.borderWidth = 3;

    if (isDark) {
      let nodeDarkColor = darkColors.find((k) => k.group === node.group);
      let nodeDarkColorBackground = nodeDarkColor?.background ?? "white";
      node.font = { color: nodeDarkColorBackground };
    } else {
      let nodeLightColor = lightColors.find((k) => k.group === node.group);
      let nodeLightColorBackground = nodeLightColor?.background ?? "white";
      node.font = { color: nodeLightColorBackground };
    }
  };

  const makeLeafNodeDifferentByDataOwner = (node) => {
    node.shape = "circularImage";
    node.group = "file";

    if (node.cid === 8) {
      node.image = isDark ? file_80 : file_80_light;
      node.color = {
        background: "#310049",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 7) {
      node.image = isDark ? file_70 : file_70_light;
      node.color = {
        background: "#130A66",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 3) {
      node.image = isDark ? file_30 : file_30_light;
      node.color = {
        background: "#131F00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 2) {
      node.image = isDark ? file_20 : file_20_light;
      node.color = {
        background: "#351000",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 6) {
      node.image = isDark ? file_60 : file_60_light;
      node.color = {
        background: "#001D2E",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 5) {
      node.image = isDark ? file_50 : file_50_light;
      node.color = {
        background: "#002012",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 4) {
      node.image = isDark ? file_40 : file_40_light;
      node.color = {
        background: "#002103",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 9) {
      node.image = isDark ? file_90 : file_90_light;
      node.color = {
        background: "#231B00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 1) {
      node.image = isDark ? file_10 : file_10_light;
      node.color = {
        background: "#3F001D",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }

    node.imagePadding = 2;
    node.borderWidth = 0;
    node.borderWidthSelected = 0;
    node.font = {
      color: "transparent",
      size: 0,
    };

    node.size = 20;
  };

  const makeLeafNodeDifferentByShopping = (node) => {
    node.shape = "circularImage";
    node.group = "file";

    if (node.cid === 8) {
      node.image = isDark ? list_80 : list_80_light;
      node.color = {
        background: "#310049",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 7) {
      node.image = isDark ? list_70 : list_70_light;
      node.color = {
        background: "#130A66",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 3) {
      node.image = isDark ? list_30 : list_30_light;
      node.color = {
        background: "#131F00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 2) {
      node.image = isDark ? list_20 : list_20_light;
      node.color = {
        background: "#351000",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 6) {
      node.image = isDark ? list_60 : list_60_light;
      node.color = {
        background: "#001D2E",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 5) {
      node.image = isDark ? list_50 : list_50_light;
      node.color = {
        background: "#002012",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 4) {
      node.image = isDark ? list_40 : list_40_light;
      node.color = {
        background: "#002103",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 9) {
      node.image = isDark ? list_90 : list_90_light;
      node.color = {
        background: "#231B00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 1) {
      node.image = isDark ? list_10 : list_10_light;
      node.color = {
        background: "#3F001D",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }

    if (node.cid === undefined) {
      node.image = isDark ? list_10 : list_10_light;
      node.color = {
        background: "#3F001D",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }

    node.imagePadding = 2;
    node.borderWidth = 0;
    node.borderWidthSelected = 0;
    node.font = {
      color: "transparent",
      size: 0,
    };

    node.size = 20;
  };

  const makeSeriesNodeDifferent = (node) => {
    node.shape = "circularImage";
    node.group = "file";

    if (node.cid === 8) {
      node.image = isDark ? diagram_80 : diagram_80_light;
      node.color = {
        background: "#310049",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 7) {
      node.image = isDark ? diagram_70 : diagram_70_light;
      node.color = {
        background: "#130A66",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 3) {
      node.image = isDark ? diagram_30 : diagram_30_light;
      node.color = {
        background: "#131F00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 2) {
      node.image = isDark ? diagram_20 : diagram_20_light;
      node.color = {
        background: "#351000",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 6) {
      node.image = isDark ? diagram_60 : diagram_60_light;
      node.color = {
        background: "#001D2E",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 5) {
      node.image = isDark ? diagram_50 : diagram_50_light;
      node.color = {
        background: "#002012",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 4) {
      node.image = isDark ? diagram_40 : diagram_40_light;
      node.color = {
        background: "#002103",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 9) {
      node.image = isDark ? diagram_90 : diagram_90_light;
      node.color = {
        background: "#231B00",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }
    if (node.cid === 1) {
      node.image = isDark ? diagram_10 : diagram_10_light;
      node.color = {
        background: "#3F001D",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }

    if (node.cid === undefined) {
      node.image = isDark ? diagram_10 : diagram_10_light;
      node.color = {
        background: "#3F001D",
        highlight: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
        hover: {
          background: isDark ? "#FFFFFF" : "#151828",
        },
      };
    }

    node.imagePadding = 2;
    node.borderWidth = 0;
    node.borderWidthSelected = 0;
    node.font = {
      color: "transparent",
      size: 0,
    };

    node.size = 20;
  };

  const makeTagEdgeColor = (processedGraph, edge) => {
    if (edge._type === RELATION_BRIDGE_LINK) {
      let fromNodeId = edge.from;
      let fromNode = processedGraph.aux.getNodeById(fromNodeId);

      if (fromNode && fromNode.label !== "User Files") {
        const group = fromNode.cid + "" + fromNode.level + GROUP_FULL;
        if (fromNode.group !== "file") {
          fromNode.group = fromNode.group.replace("b", "a");
        }
        if (isDark) {
          let darkColor = darkColors.find((k) => k.group === group);
          let darkColorBackground = darkColor?.background ?? "#777FAC";
          edge.color = { color: darkColorBackground };
        } else {
          let lightColor = lightColors.find((k) => k.group === group);
          let lightColorBackground = lightColor?.background ?? "#C0C4D9";
          edge.color = { color: lightColorBackground };
        }

        edge.width = 1;
      }
    }
  };

  return (
    <>
      {isVisibility5 && <DwinityLoader />}
      {graphLoadError && !isVisibility5 && (
        <div
          className="d-none d-lg-flex flex-column align-items-center justify-content-center text-center"
          style={{ minHeight: "420px", width: "100%", gap: "16px" }}
          role="alert"
        >
          <div>{graphLoadError}</div>
          <button
            type="button"
            className="btn btn-outline-light"
            onClick={() => {
              setGraphLoadError("");
              setIsVisibility5(true);
              setGraphRefreshed((value) => !value);
            }}
          >
            {t("common.retry", { defaultValue: "Retry" })}
          </button>
        </div>
      )}

      <div
        className={`desktop-explorer-shell d-none d-lg-flex align-items-center justify-content-center${isChatOpen ? " chat-docked" : ""}`}
        style={{ width: "100%" }}
      >
        {isVisibility2 && (
          <div style={{ width: "100%" }}>
            <div className="dashboard">
              <div className="explorer-top-bar">
                <div className="explorer-top-bar-left">
                  <MDBTabs className="explorer-tabs mb-2">
                    <MDBTabsItem>
                      <MDBTabsLink
                        className="left-link"
                        onClick={() => {
                          handleBasicClick("tab1");
                          setIsUserGraph(true);
                        }}
                        active={basicActive === "tab1"}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('files.explorer.title')}
                      </MDBTabsLink>
                    </MDBTabsItem>

                    <MDBTabsItem>
                      <MDBTabsLink
                        className="right-link"
                        onClick={() => {
                          handleBasicClick("tab2");
                          setIsUserGraph(false);
                        }}
                        active={basicActive === "tab2"}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2"/>
                          <circle cx="5" cy="6" r="2" stroke="white" strokeWidth="2"/>
                          <circle cx="19" cy="6" r="2" stroke="white" strokeWidth="2"/>
                          <circle cx="5" cy="18" r="2" stroke="white" strokeWidth="2"/>
                          <circle cx="19" cy="18" r="2" stroke="white" strokeWidth="2"/>
                          <line x1="9.5" y1="10.5" x2="6.5" y2="7.5" stroke="white" strokeWidth="1.5"/>
                          <line x1="14.5" y1="10.5" x2="17.5" y2="7.5" stroke="white" strokeWidth="1.5"/>
                          <line x1="9.5" y1="13.5" x2="6.5" y2="16.5" stroke="white" strokeWidth="1.5"/>
                          <line x1="14.5" y1="13.5" x2="17.5" y2="16.5" stroke="white" strokeWidth="1.5"/>
                        </svg>
                        {t('files.explorer.graphView')}
                      </MDBTabsLink>
                    </MDBTabsItem>
                  </MDBTabs>

                  <button
                    className="button dashboard large explorer-video-chat-trigger"
                    onClick={() => setIsChatOpen(true)}
                    title={t('mobile.chat.title')}
                  >
                    <i className="ti ti-device-tv" aria-hidden="true" />
                    <span className="text">Video Chat</span>
                  </button>
                </div>

                <div className="explorer-top-bar-right">
                  <button
                    className="button dashboard large explorer-upload-action"
                    style={{ whiteSpace: "nowrap", padding: "6px 16px" }}
                    onClick={() =>
                      context.openModal("importorupload", "", {
                        processedGraph: processedGraph,
                        onFinish: refreshGraph,
                        onError: (errorString) => {
                          context.closeModal();
                        },
                      })
                    }
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10 17.5C8.51664 17.5 7.0666 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35472 9.99168 2.64411 8.53683C2.9335 7.08197 3.64781 5.7456 4.6967 4.6967C5.7456 3.64781 7.08197 2.9335 8.53683 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.07091C14.2406 3.63856 15.4119 4.59986 16.236 5.83323C17.0601 7.0666 17.5 8.51664 17.5 10C17.4978 11.9885 16.707 13.8949 15.3009 15.3009C13.8949 16.707 11.9885 17.4978 10 17.5V17.5ZM10 3.75C8.76387 3.75 7.5555 4.11656 6.52769 4.80332C5.49988 5.49008 4.6988 6.46619 4.22576 7.60823C3.75271 8.75027 3.62894 10.0069 3.8701 11.2193C4.11125 12.4317 4.70651 13.5453 5.58059 14.4194C6.45466 15.2935 7.56831 15.8888 8.78069 16.1299C9.99307 16.3711 11.2497 16.2473 12.3918 15.7743C13.5338 15.3012 14.5099 14.5001 15.1967 13.4723C15.8834 12.4445 16.25 11.2361 16.25 10C16.2481 8.343 15.589 6.75442 14.4173 5.58273C13.2456 4.41105 11.657 3.75195 10 3.75V3.75ZM13.75 9.21875H10.7813V6.25C10.7813 6.0428 10.6989 5.84409 10.5524 5.69758C10.4059 5.55106 10.2072 5.46875 10 5.46875C9.7928 5.46875 9.59409 5.55106 9.44758 5.69758C9.30106 5.84409 9.21875 6.0428 9.21875 6.25V9.21875H6.25C6.0428 9.21875 5.84409 9.30106 5.69758 9.44758C5.55106 9.59409 5.46875 9.7928 5.46875 10C5.46875 10.2072 5.55106 10.4059 5.69758 10.5524C5.84409 10.6989 6.0428 10.7813 6.25 10.7813H9.21875V13.75C9.21875 13.9572 9.30106 14.1559 9.44758 14.3024C9.59409 14.4489 9.7928 14.5313 10 14.5313C10.2072 14.5313 10.4059 14.4489 10.5524 14.3024C10.6989 14.1559 10.7813 13.9572 10.7813 13.75V10.7813H13.75C13.9572 10.7813 14.1559 10.6989 14.3024 10.5524C14.4489 10.4059 14.5313 10.2072 14.5313 10C14.5313 9.7928 14.4489 9.59409 14.3024 9.44758C14.1559 9.30106 13.9572 9.21875 13.75 9.21875Z"
                        fill="white"
                      />
                    </svg>
                    <span className="text">{t('files.upload.addMoreFiles')}</span>
                  </button>
                </div>
              </div>
              <div className="table-component-tab">
                <MDBTabsContent>
                  <MDBTabsPane show={basicActive === "tab1"}>
                    <ExplorerDataComponent
                      graphData={graphData}
                      loadedGraph={processedGraph}
                      isLocalRender={isLocalRender}
                      refreshGraph={refreshGraph}
                      graphRefreshed={graphRefreshed}
                      setIsMultiDownload={(value) => setIsMultiDownload(value)}
                      setIsVisibility5={(value) => setIsVisibility5(value)}
                      isExplorerView={basicActive === "tab1"}
                      downloadSignal={downloadAbortControllerRef.current.signal}
                    />
                  </MDBTabsPane>
                  <MDBTabsPane show={basicActive === "tab2"}>
                    {basicActive === "tab2" && graphData && (
                      <GraphUserComponent2
                        graphData={graphData}
                        isUserGraph={isUserGraph}
                        setGraphData={(array) => setGraphData(array)}
                        processedGraph={processedGraph}
                        isLocalRender={isLocalRender}
                        refreshGraph={refreshGraph}
                        graphRefreshed={graphRefreshed}
                        isGrapView={basicActive === "tab2"}
                      />
                    )}
                  </MDBTabsPane>
                  {/* Network tab – hidden from navigation but kept for future use */}
                  <MDBTabsPane show={basicActive === "tab3"}>
                    {basicActive === "tab3" && graphData && (
                      <NetworkViewGraph
                        graphData={graphData}
                        processedGraph={processedGraph}
                        isUserGraph={isUserGraph}
                        setGraphData={(array) => setGraphData(array)}
                        isLocalRender={isLocalRender}
                        refreshGraph={refreshGraph}
                        graphRefreshed={graphRefreshed}
                        isVisible={basicActive === "tab3"}
                      />
                    )}
                  </MDBTabsPane>
                </MDBTabsContent>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex d-lg-none align-items-center justify-content-center" style={{ width: "100%" }}>
        {isVisibility2 && (
          <div style={{ width: "100%" }}>
            <div className="dashboard">
              <div className="table-component-tab">
                <ExplorerDataComponent
                  graphData={graphData}
                  loadedGraph={processedGraph}
                  isLocalRender={isLocalRender}
                  refreshGraph={refreshGraph}
                  graphRefreshed={graphRefreshed}
                  setIsMultiDownload={(value) => setIsMultiDownload(value)}
                  setIsVisibility5={(value) => setIsVisibility5(value)}
                  isExplorerView={basicActive === "tab1"}
                  downloadSignal={downloadAbortControllerRef.current.signal}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="ticket-div">
        {isDoneTicket && (
          <>
            <NotificationsTicket
              close={() => {
                setIsDoneTicket(false);
              }}
              text={t('files.upload.cancelSuccess')}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>

      {context.getState()?.isProgress && (
        <div className="proggress-div proggress-div-redesigned">
          {/* Header */}
          <div className="progress-header">
            <img className="dwin-logo" src={logo} alt="logo" />
            <span className="title-text" id="file-details">
              {!isMultiDownload
                ? t('files.upload.transferInProgress')
                : window.showDirectoryPicker
                  ? t('files.upload.downloadInProgress')
                  : t('files.upload.downloadZipInProgress')}
            </span>
          </div>

          {/* Main content - two columns */}
          <div className="progress-content">
            {/* Left column - Current file progress */}
            <div className="progress-left-column">
              <div className="current-file-section">
                <h4 className="section-title">{t('files.upload.currentFile')}</h4>
                <div className="file-info-card">
                  <span className="file-name" id="file-name">
                    {t('common.status.preparing')}
                  </span>
                  <div className="progress-wrapper">
                    <span className="progress-pct" id="progress-bar-label">0%</span>
                    <div className="progress-bar-track">
                      <div className="progress-bar-fill" id="progress-bar" style={{ width: '0%' }}></div>
                    </div>
                  </div>
                  <span className="detail-text" id="file-size"></span>
                </div>
              </div>

              <div className="overall-progress-section">
                <div className="file-counter">
                  <span className="file-name" id="file-number">
                    {t('files.upload.fileOfTotal', { current: 0, total: 0 })}
                  </span>
                </div>
                <div className="loading-indicator" id="upload-loading-indicator" style={{ display: 'flex' }}>
                  <DwinityLoader size={16} fullScreen={false} inline />
                  <span className="loading-text" id="upload-loading-text">{t('files.upload.preparingUpload')}</span>
                </div>
                <div className="time-info">
                  <span className="detail-text-timer" id="file-timer-text"></span>
                  <span className="detail-text" id="file-timer"></span>
                </div>
              </div>

              <div className="cancel-section">
                <button
                  className="button outline medium"
                  disabled={isCancelling}
                  onClick={async () => {
                    try {
                      setIsCancelling(true);
                      isCancellingRef.current = true;
                      setIsCancellingUpload(true); // Set global flag to ignore messages in uploadworkerutil
                      setUploadStatus("cancelling");
                      setStatusMessage(t('files.upload.stoppingUpload'));

                      // Cancel orchestrated upload if active
                      if (isOrchestratedUploadActive()) {
                        console.log("Cancelling orchestrated upload...");
                        cancelOrchestratedUpload();
                      }
                      // Always clear localStorage batchId to prevent resume modal after cancel
                      clearBatchId();

                      const completedList = Array.from(completedPaths);
                      const allPaths =
                        currentFilePath && !completedPaths.has(currentFilePath)
                          ? [...completedList, currentFilePath]
                          : completedList;
                      const moduleTracked = getAllTrackedFiles();
                      const combinedPaths = [...new Set([...allPaths, ...moduleTracked])];
                      console.log(
                        `Cancel: React state has ${completedList.length} completed, current: ${currentFilePath}, module: ${moduleTracked.length}, combined: ${combinedPaths.length}`,
                      );

                      await interrupt();
                      await removeAll();

                      setStatusMessage(t('files.upload.cancellingUploads'));

                      const { deleted, failed, aborted, foldersDeleted } =
                        await deleteUploadedFilesOnCancel((current, total, path, status) => {
                          const fileName = path.split("/").pop() || path;
                          if (status === "aborting") {
                            setStatusMessage(`Aborting ${current}/${total}: ${fileName}`);
                          } else if (status === "scanning") {
                            setStatusMessage(`Scanning for remaining files: ${fileName}`);
                          } else if (status === "cleaning remaining") {
                            setStatusMessage(`Cleaning remaining: ${fileName}`);
                          } else if (status === "cleaning folders") {
                            setStatusMessage(t('files.upload.cleaningFolders'));
                          } else {
                            setStatusMessage(`Deleting ${current}/${total}: ${fileName}`);
                          }
                        }, combinedPaths);

                      if (deleted > 0 || failed > 0 || aborted > 0 || foldersDeleted > 0) {
                        console.log(
                          `Cancel cleanup: ${aborted} aborted, ${deleted} deleted, ${failed} failed, ${foldersDeleted} folders`,
                        );
                        let summary = "";
                        if (aborted > 0) summary += `Aborted ${aborted} / ${aborted} abgebrochen`;
                        if (deleted > 0) summary += `${summary ? ", " : ""}Deleted ${deleted} / ${deleted} gelöscht`;
                        if (foldersDeleted > 0) summary += `, ${foldersDeleted} ${t('common.labels.folders')}`;
                        if (failed > 0) summary += ` (${failed} ${t('common.status.failed')})`;
                        setStatusMessage(summary || t('files.upload.cleanupComplete'));
                        await new Promise((resolve) => setTimeout(resolve, 2000));
                      }

                      // Since worker doesn't send "finished" on interrupt, the in-memory graph changes won't be saved.
                      // Just reload the graph from backend to discard all in-memory changes.
                      setStatusMessage(t('common.status.loading'));
                      refreshGraph();

                      if (failed > 0) {
                        console.warn(
                          `${failed} files could not be deleted from storage, they may remain in cloud storage`,
                        );
                      }
                    } catch (error) {
                      console.error("Cancel error:", error);
                      setStatusMessage(t('common.status.failed'));
                      await new Promise((resolve) => setTimeout(resolve, 1500));
                    } finally {
                      resetUploadState();
                      setFolderProgress([]);
                      setUploadStatus("idle");
                      setStatusMessage("");
                      setIsCancelling(false);
                      isCancellingRef.current = false;
                      setIsCancellingUpload(false); // Reset global flag
                      setIsDoneTicket(true);
                      context.isProgress(false);
                    }
                  }}
                >
                  <span className="text">{isCancelling ? t('common.status.processing') : t('common.buttons.cancel')}</span>
                </button>
              </div>
            </div>

            {/* Right column - Info and folder progress */}
            <div className="progress-right-column">
              <UploadProgressInfoComponent
                folders={folderProgress}
                currentFolder={currentFolderPath}
                uploadStatus={uploadStatus}
                statusMessage={statusMessage}
              />
            </div>
          </div>
        </div>
      )}

      <ChatModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        walletAddress={selectedAccount}
        provider={selectedWallet?.provider || null}
      />
    </>
  );
}
